var _path, _path2, _ellipse, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.33318C0 2.78089 0.447715 2.33318 1 2.33318H3.20008V7.66664H0.999999C0.447714 7.66664 0 7.21892 0 6.66664V3.33318Z",
    fill: "#AE1942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20032 7.66663V2.33317L4.80036 1.66648L6.4004 0.999802V9L4.80036 8.33331L3.20032 7.66663Z",
    fill: "#AE1942"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.39997,
    cy: 4.9999,
    rx: 1.60004,
    ry: 1.33337,
    fill: "#AE1942"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L11.6056 3.21115C12.1686 4.33726 12.1686 5.66274 11.6056 6.78885L11 8",
    stroke: "#AE1942"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3V3C9.88889 4.18519 9.88889 5.81481 9 7V7",
    stroke: "#AE1942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1L13.9733 3.59551C14.3129 4.50105 14.3129 5.49895 13.9733 6.40449L13 9",
    stroke: "#AE1942"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volume-icon.bbed5a5aaeda720bd531a9e55c416433.svg";
export { ForwardRef as ReactComponent };